import { render, staticRenderFns } from "./mobileSubmitOrder.vue?vue&type=template&id=d5435430&scoped=true"
import script from "./mobileSubmitOrder.vue?vue&type=script&lang=js"
export * from "./mobileSubmitOrder.vue?vue&type=script&lang=js"
import style0 from "./mobileSubmitOrder.vue?vue&type=style&index=0&id=d5435430&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5435430",
  null
  
)

export default component.exports